import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  container: {
    display: "flex",
    gap: "10px",
    marginTop: "8px",
  },
  card: {
    flex: "1 1 0",
    padding: "10px 14px",
    border: "1.5px solid #e0e0e0",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "all 0.15s ease",
    backgroundColor: "#fff",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    "&:hover": {
      borderColor: "#3a6ed4",
      backgroundColor: "#f5f8ff",
    },
  },
  cardSelected: {
    borderColor: "#3a6ed4",
    backgroundColor: "#f0f4ff",
  },
  icon: {
    fontSize: "18px",
    flexShrink: 0,
  },
  textWrap: {
    minWidth: 0,
  },
  title: {
    fontWeight: "600",
    fontSize: "13px",
    color: "#1a1a1a",
    lineHeight: "1.2",
  },
  subtext: {
    fontSize: "10px",
    color: "#9ca3af",
    lineHeight: "1.3",
    marginTop: "1px",
  },
});

const methods = [
  {
    id: "upload",
    icon: "📄",
    title: "Upload Existing JD",
    subtext: "Upload a PDF, DOC, or DOCX file",
  },
  {
    id: "ai",
    icon: "✨",
    title: "Generate with AI",
    subtext: "Auto-generate from the job details you've entered",
  },
  {
    id: "manual",
    icon: "✍️",
    title: "Write Manually",
    subtext: "Write or paste your own job description",
  },
];

const JDMethodSelector = ({ selectedMethod, onSelect }) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      {methods.map((method) => (
        <div
          key={method.id}
          className={`${classes.card} ${
            selectedMethod === method.id ? classes.cardSelected : ""
          }`}
          onClick={() => onSelect(method.id)}
        >
          <span className={classes.icon}>{method.icon}</span>
          <div className={classes.textWrap}>
            <div className={classes.title}>{method.title}</div>
            <div className={classes.subtext}>{method.subtext}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default JDMethodSelector;
